export default {
  'examineText': ['未申请', '审核中', '审核未通过', '审核通过'],
  'operation': '操作',
  'edit': '编辑',
  'download': '点击下载'
}
